import {
	ChangeDetectionStrategy,
	Component,
	ContentChild,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	SimpleChange,
	ViewChild
} from '@angular/core';
import {ISelectionBoxOptions} from "../../interfaces/Iselection.box.options";
import {ISelectionBoxItem} from "../../interfaces/Iselection.box.item";
import {ISelectionBoxActionEvent} from "../../interfaces/Iselection.box.action.event";
import {SelectionListItemTemplateDirective} from "../selection.box.content/selection.list/selection.list.item.template";
import {SelectionBoxBarComponent} from "../selection.box.bar/selection.box.bar/selection.box.bar.components";
import {SearchTermService} from "../../../../services/search.term.service";


@Component({
	selector: 'cp-selection-box',
	templateUrl: './selection.box.html',
	styleUrls: ['./selection.box.scss'],
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class SelectionBoxComponent implements OnChanges{

	@Input() options: ISelectionBoxOptions;
	@Input() disabled: boolean;
	@Input() placeholderTranslationKey: string;

	@Output() selectItem: EventEmitter<ISelectionBoxItem> = new EventEmitter<ISelectionBoxItem>();
	@Output() actionClick: EventEmitter<ISelectionBoxActionEvent> = new EventEmitter<ISelectionBoxActionEvent>();
	@Output() searchItems: EventEmitter<string> = new EventEmitter<string>();
	@Output() isDiagramShow: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() subTitleClick = new EventEmitter();

	@ContentChild("selectionListItemTemplate ",{static:false}) public itemTemplate;

	@ViewChild(SelectionBoxBarComponent,{static:false}) searchBoxBar:SelectionBoxBarComponent;

	public displayDiagram: boolean;
	public searchTerms: string[] = [];

	constructor(private searchTermService: SearchTermService) { }

	ngOnChanges(changes: {[p: string]: SimpleChange}) {
		let optionsChange = changes["options"];
		if (optionsChange && optionsChange.currentValue !== optionsChange.previousValue){
			if ((optionsChange.firstChange && optionsChange.currentValue.diagramPath) ||
				(!optionsChange.firstChange && (optionsChange.currentValue.diagramPath !==  optionsChange.previousValue.diagramPath))){
				this.displayDiagram = this.options.diagramPath ? true: false;
				this.isDiagramShow.emit(this.displayDiagram);
			}
		}
	}

	public clearSearch(){
		this.searchTerms = [];
		this.searchBoxBar.clearSearch();
	}

	public onSelect(item: ISelectionBoxItem) {
		this.selectItem.emit(item);
	}

	public onSearch(str: string) {
		this.searchItems.emit(str);
		this.searchTerms = this.searchTermService.splitSearchTerm(str);
	}

	public onActionClick(event:ISelectionBoxActionEvent){
		this.actionClick.emit(event);
	}

	public onDiagramIconClick(){
		this.displayDiagram = !this.displayDiagram;
		this.isDiagramShow.emit(this.displayDiagram);
	}

	public onSubTitleClick(){
		this.subTitleClick.emit(null);
	}
}




